import React, { useState, useEffect } from 'react';

interface HeadlineData {
  text: string;
  emoji: string;
  highlight: string;
}

interface RotatingHeadlineProps {
  headlines: HeadlineData[];
  interval?: number;
  className?: string;
}

const RotatingHeadline: React.FC<RotatingHeadlineProps> = ({ 
  headlines, 
  interval = 4000, 
  className = '' 
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isChanging, setIsChanging] = useState(false);

  useEffect(() => {
    const rotateHeadline = () => {
      setIsChanging(true);
      
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % headlines.length);
        
        setTimeout(() => {
          setIsChanging(false);
        }, 500);
      }, 500);
    };

    const intervalId = setInterval(rotateHeadline, interval);
    return () => clearInterval(intervalId);
  }, [headlines.length, interval]);

  const formatHeadline = (headline: HeadlineData) => {
    const { text, emoji, highlight } = headline;
    
    // Remove emoji from text and create separate elements
    const textWithoutEmoji = text.replace(emoji, '').trim();
    
    // Replace highlight text with span
    const formattedText = textWithoutEmoji.replace(
      highlight,
      `<span class="headline-highlight">${highlight}</span>`
    );
    
    return {
      emoji,
      formattedText
    };
  };

  const currentHeadline = headlines[currentIndex];
  const { emoji, formattedText } = formatHeadline(currentHeadline);

  return (
    <span className={`rotating-headline ${isChanging ? 'changing' : ''} ${className}`}>
      <span className="headline-emoji">{emoji}</span>
      <span 
        dangerouslySetInnerHTML={{ __html: formattedText }}
      />
    </span>
  );
};

export default RotatingHeadline; 